export function formatAICreditsResetDate(dateStr: string | undefined, locale: string | undefined): string {
  if (!dateStr) return ''

  const date = new Date(dateStr)
  if (!Number.isFinite(date.getTime())) return dateStr

  try {
    return new Intl.DateTimeFormat(locale || 'en', {
      day: 'numeric',
      month: 'long',
      timeZone: 'UTC',
    }).format(date)
  } catch {
    return dateStr
  }
}
